const Error = () => {
  return "Something went wrong!";
};
export default Error;
